/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Notification_Option_Not_SupportedInputs */

const es_co2_error_notification_option_not_supported = /** @type {(inputs: Error_Notification_Option_Not_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opción de notificación no válida.`)
};

/**

* @param {Error_Notification_Option_Not_SupportedInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_notification_option_not_supported = /** @type {((inputs?: Error_Notification_Option_Not_SupportedInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Notification_Option_Not_SupportedInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_notification_option_not_supported(inputs)
});